import { render } from "./ManagerSystemMaintenanceMessage.vue?vue&type=template&id=38637cb2&scoped=true"
import script from "./ManagerSystemMaintenanceMessage.vue?vue&type=script&lang=js"
export * from "./ManagerSystemMaintenanceMessage.vue?vue&type=script&lang=js"

import "./ManagerSystemMaintenanceMessage.vue?vue&type=style&index=0&id=38637cb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38637cb2"]])

export default __exports__